import React, { Component } from 'react';
import classnames from 'classnames';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import fr from 'date-fns/locale/fr';
import setHours from "date-fns/setHours";
import setMinutes from "date-fns/setMinutes";
import { cloneDeep, isEqual } from "lodash";

import { MINOR_CHOICES, TESTIMONIAL_CHOICES } from '../TestimonialWizard';


registerLocale('fr', fr);


class Filters extends Component {

  constructor(props) {
    super(props);
    this.originalState = {
      optin: "-1",
      optin_contact: "-1",
      moderated: "-1",
      email: "",
      message: "",
      startDate: null,
      endDate: null,
      testimonial_choice: "-1",
      major_reason_choice: "-1",
      minor_reason_choice: "-1",
      administrative_unit_name: ""
    };
    this.state = cloneDeep(this.originalState);
    this.state.menuOpened = false;
  }

  isFilteringOn() {
    // Check if any filter is different from its initial value;
    // skip "menuOpened".
    let testState = cloneDeep(this.state);
    delete testState.menuOpened;
    return !isEqual(testState, this.originalState);
  }

  toggleVisible = () => {
    this.setState({menuOpened: !this.state.menuOpened});
  }

  handleChange = (event) => {
    const target = event.target;
    if (target != null) {
      const value = target.type === 'checkbox' ? target.checked : target.value;
      const name = target.name;

      this.setState({
        [name]: value
      });

      // Hack for dependent dropdowns: reset the second one when the first one has changed
      if (name == "testimonial_choice") {
        this.setState({major_reason_choice: "-1"});
      }
    }
  }

  handleSubmit = (event) => {
    let out = cloneDeep(this.state);
    delete out.menuOpened;
    this.props.onSubmit(out);
    this.setState({menuOpened: false});
  }

  render() {
    /*
    opt-in
    opt-in juridique
    (- opt-in média si il est créé)
    e-mail
    affiché / non affiché sur le site
    catégories (en priorité niveaux 2 et 3)
    recherche dans le texte du témoignage (mot / expression)
    plage de dates

    1) plage de dates (date de création)
    2) affiché / non affiché sur le site (modération)
    3) recherche dans le texte du témoignage (mot / expression) (message)
    4) e-mail
    5) catégories (je suis témoin, plus précisément, c'est lié)
    6) optins
    */
    let menuClass = this.state.menuOpened ? "is-active" : "";
    let buttonClass = this.isFilteringOn() ? "has-text-link" : "";
    let testimonialChoices = TESTIMONIAL_CHOICES;
    let testimonialChoice = parseInt(this.state.testimonial_choice, 0);
    let majorChoices = !isNaN(testimonialChoice) && testimonialChoice != -1 ?
      testimonialChoices[testimonialChoice]["major_choices"] : {};
    let minorChoices = MINOR_CHOICES;

    return (
      <div className={classnames("gp-filters-dropdown dropdown is-pulled-right is-right", menuClass)}>
        <div className="dropdown-trigger">
          <button
            className={classnames("button", buttonClass)}
            aria-haspopup="true"
            aria-controls="dropdown-menu2"
            onClick={this.toggleVisible}>
            <span className="icon">
              <i className="fas fa-filter"></i>
            </span>
            <span>Filtres</span>
            <span className="icon is-small">
              <i className="fas fa-angle-down" aria-hidden="true"></i>
            </span>
          </button>
        </div>
        <div className="dropdown-menu bo-gp-filters" id="dropdown-menu2" role="menu">
          <div className="dropdown-content">
            <div className="field dropdown-item">
              <div className="columns">
                <div className="column">
                  <label className="label">Témoignage à partir du (inclus)</label>
                  <div className="columns is-vcentered">
                    <div className="column">
                      <DatePicker
                        locale="fr"
                        selected={this.state.startDate}
                        onChange={date => this.setState({startDate: date})}
                        className="input"
                        dateFormat="dd/MM/yyyy"
                      />
                    </div>
                    <div className="column">
                      { this.state.startDate !== null ? (<button
                        className="button is-small"
                        onClick={() => this.setState({startDate: null})}>RAZ</button>) : '' }
                    </div>
                  </div>
                </div>
                <div className="column">
                  <label className="label">jusqu'au (inclus)</label>
                  <div className="columns is-vcentered">
                    <div className="column">
                      <DatePicker
                        locale="fr"
                        selected={this.state.endDate}
                        onChange={date => this.setState({endDate: date})}
                        className="input"
                        dateFormat="dd/MM/yyyy"
                      />
                    </div>
                    <div className="column">
                      { this.state.endDate !== null ? (<button
                        className="button is-small"
                        onClick={() => this.setState({endDate: null})}>RAZ</button>) : '' }
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr className="dropdown-divider" />
            <div className="field dropdown-item">
              <div className="columns">
                <div className="column">
                  <div className="control">
                    <label className="label">Opt-in info</label>
                    <div className="select">
                      <select
                        name="optin"
                        onChange={this.handleChange}
                        value={this.state.optin}
                        >
                        <option value="-1">Indifférent</option>
                        <option value="1">Oui</option>
                        <option value="0">Non</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="column">
                  <div className="control">
                    <label className="label">Opt-in juridique</label>
                    <div className="select">
                      <select
                        name="optin_contact"
                        onChange={this.handleChange}
                        value={this.state.optin_contact}
                        >
                        <option value="-1">Indifférent</option>
                        <option value="1">Oui</option>
                        <option value="0">Non</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="column">
                  <div className="control">
                    <label className="label">Opt-in média</label>
                    <div className="select">
                      <select
                        name="optin_contact_media"
                        onChange={this.handleChange}
                        value={this.state.optin_contact_media}
                        >
                        <option value="-1">Indifférent</option>
                        <option value="1">Oui</option>
                        <option value="0">Non</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr className="dropdown-divider" />
            <div className="field dropdown-item">
              <div className="control">
                <label className="label">Affiché sur le site</label>
                <div className="select">
                  <select name="moderated"
                    onChange={this.handleChange}
                    value={this.state.moderated}
                    >
                    <option value="-1">Indifférent</option>
                    <option value="0">Oui</option>
                    <option value="1">Non</option>
                  </select>
                </div>
              </div>
            </div>
            <hr className="dropdown-divider" />
            <div className="field dropdown-item">
              <label className="label">Mot ou expression dans le témoignage</label>
              <input
                type="text"
                maxLength="80"
                className="input"
                name="message"
                onChange={this.handleChange}
                value={this.state.message}
              />
            </div>
            <hr className="dropdown-divider" />
            <div className="field dropdown-item">
              <label className="label">E-mail</label>
              <input
                type="text"
                maxLength="80"
                className="input"
                name="email"
                onChange={this.handleChange}
                value={this.state.email}
              />
            </div>
            <hr className="dropdown-divider" />
            <div className="field dropdown-item">
              <label className="label">Partie du nom du département / territoire</label>
              <input
                type="text"
                maxLength="80"
                className="input"
                name="administrative_unit_name"
                onChange={this.handleChange}
                value={this.state.administrative_unit_name}
              />
            </div>
            <hr className="dropdown-divider" />
            <div className="field dropdown-item">
              <div className="columns">
                <div className="column">
                  <div className="control">
                    <label className="label">Je suis témoin</label>
                    <div className="select">
                      <select
                        name="testimonial_choice"
                        onChange={this.handleChange}
                        value={this.state.testimonial_choice}
                        >
                        <option value="-1">Indifférent</option>
                        {
                          Object.entries(testimonialChoices).map(([key, {label}]) =>
                            (<option key={key} value={key}>{label}</option>)
                          )
                        }
                      </select>
                    </div>
                  </div>
                </div>
                <div className="column">
                  <div className="control">
                    <label className="label">Plus précisément</label>
                    <div className="select">
                      <select
                        name="major_reason_choice"
                        onChange={this.handleChange}
                        value={this.state.major_reason_choice}
                        >
                        <option value="-1">Indifférent</option>
                        {
                          Object.entries(majorChoices).map(([key, {label}]) =>
                            (<option key={key} value={key}>{label}</option>)
                          )
                        }
                      </select>
                    </div>
                  </div>
                </div>
                <div className="column">
                  <div className="control">
                    <label className="label">C'est lié</label>
                    <div className="select">
                      <select
                        name="minor_reason_choice"
                        onChange={this.handleChange}
                        value={this.state.minor_reason_choice}
                        >
                        <option value="-1">Indifférent</option>
                        {
                          minorChoices.map((elem) =>    // elem = [group label, minor choices]
                            (<optgroup label={elem[0]}>
                              {
                                Object.entries(elem[1]).map(([key, {label}]) =>
                                  (<option key={key} value={key}>{label}</option>)
                                )
                              }
                             </optgroup>)
                          )
                        }
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr className="dropdown-divider" />

            <div className="field dropdown-item">
              <button
                className="button is-link gp-button-form-submit"
                onClick={this.handleSubmit}
               >
                Appliquer
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}


export default Filters;
